import $ from 'jquery';

/**
 * Custom Codes
 */

export default () => {

  $(document).ready(function() {
    if ( $('.m-menu').length ) {
      //adding a heading to the inside menu
      $('.m-menu .widget_nav_menu').each(function(){
        var mtitle = $('.m-menu .widget_nav_menu h2.widgettitle').text();
        $('<div class="wg-toggle-nav"><div class="m-lines"><span class="bar1"></span><span class="bar2"></span><span class="bar3"></span></div>'+ mtitle +'</div>').insertBefore('.m-menu .widget_nav_menu');
      });

      //mobile inner menu toggle option
      $(".wg-toggle-nav").on("click", function() {
        $(this).toggleClass("close-btn");
        $(".m-menu .widget_nav_menu").toggleClass("open-menu");
      });

    }

    $('.partner-logos .partner-logo').each(function(){
      $(this).closest('.inner').addClass('plogo-wrapper');
      //$(this).closest('.wpb_wrapper').addClass('pmain-wrapper');
    });

    $(".nectar-mobile-only.mobile-header").html($('li.header-phone').html());

  });
    
};
